var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"communicate-wrap"},[_c('img',{attrs:{"src":require('../../assets/img/communication/error.png')}}),_c('div',{staticClass:"communicate-text"},[_vm._v("会议记录已被确认")])])
}
var staticRenderFns = []

export { render, staticRenderFns }